<div class="fileUpload" [class.fileUpload--disabled]="disabled">
    <input #fileInput class="fileUpload__input" [id]="id" type="file" [name]="name" [attr.accept]="accept || null"
        [multiple]="multiple" [disabled]="disabled" (change)="onFileChange($event)">

    <button class="fileUpload__trigger" type="button" [disabled]="disabled" (click)="fileInput.click()">
        {{ multiple ? 'Choose files' : 'Choose file' }}
    </button>

    @if (selectedFileNames.length) {
    <div class="fileUpload__selection" [class.fileUpload__selection--multiple]="multiple">
        @if (multiple) {
        <ul class="fileUpload__list">
            @for (fileName of selectedFileNames; track fileName) {
            <li [title]="fileName">{{ fileName }}</li>
            }
        </ul>
        } @else {
        <span class="fileUpload__fileName" [title]="selectedFileNames[0]">{{ selectedFileNames[0] }}</span>
        }
    </div>
    } @else {
    <span class="fileUpload__empty">No file selected</span>
    }
</div>
